import * as ServiceWrapper from './ServiceWrapper/ServiceWrapper.css';

export default {
	ServiceWrapper
};
